import {Directive, Input} from '@angular/core';

@Directive({
    selector: '[imageThumbnailUpdate]',
    host: {
        '(error)': 'updateImageThumbnail()'
    },
    standalone: false
})
 export class ImageThumbnailUpdate {

    @Input() imageObject:any;

    updateImageThumbnail() {
      if(this.imageObject && this.imageObject.image_url){
        this.imageObject.image_url  = '';
      }
    }
  }